export const MYSTERY_BET_ROUTE = 'tote/mystery'
